






















import Vue from 'vue';
import Component from 'vue-class-component';
import autocompleteItem from '../components/v-autocomplete-item.vue';
import {Area, Graph} from "../core/interface";

@Component({
    props: [
        'options',
        'value'
    ],
    components: {

    }
})
export default class Selectbox extends Vue {
    options: any;
    value: Graph | Area;
    autocompleteItemTemplate: any = autocompleteItem;
    autocompleteInputAttrs: object = {readonly: true, class: 'v-autocomplete-input v-autocomplete-input--select'};
    queryOptions: Graph[] | Area[] = [];
    autocompleteModel: Graph | Area | null = null;

    mounted() {
        this.queryOptions = this.options.filter((option: Graph | Area) => option !== this.value);
        this.autocompleteModel = this.value;
    }

    get selectModel(): string {
        return this.value.value;
    }
    set selectModel(val) {
        this.onSelectChange(val);
    }
    get getOptionsWithoutCurrent(): Graph[] | Area[] {
        return this.options.filter((option: Graph | Area) => option !== this.value);
    }
    get isMobile(): boolean {
        return (window as any).outerWidth < 425; // only check during component render
    }

    /*
        Return label for autocomplete input
     */
    private getAutocompleteValueLabel(item: any): string {
        return item ? item.name : '';
    }

    /*
        Filter autocomplete suggestion based on typed text
     */
    private updateAutocomplete(): void {
        this.queryOptions = this.options.filter((option: Graph | Area) => option !== this.value);
    }

    /*
        When selection is performed
     */
    private onSelectChange(newVal: any): void {
        // skip running this when component loads
        if(this.isMobile || (!this.isMobile && newVal !== this.autocompleteModel)) {
            Vue.gtm.trackEvent({
                category: 'Graph',
                action: 'click',
                label: 'Dropdown click',
                value: newVal
            });

            (document.activeElement as any).blur(); // blur input when selection is done(hack for using a keyboard for selection)
            this.$emit('onSelectChanged', this.isMobile ? this.options.find((option: Graph | Area) => option.value === newVal) : newVal);
        }
        this.updateAutocomplete();
    }
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/selectbox.vue